var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "commentary"
  }, [_c('ColorAvatar', {
    staticClass: "commentary__avatar",
    attrs: {
      "size": "40",
      "mobile-size": "30",
      "name": _vm.comment.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "commentary__complain"
  }, [_c('span', {
    staticClass: "link-icon link-icon_grey link-icon_dashed fz-14 commentary__pointer",
    on: {
      "click": function ($event) {
        return _vm.emit('report', {
          active: true,
          name: 'ответ'
        });
      }
    }
  }, [_c('div', {
    staticClass: "link-icon__icon-warning"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "commentary__content"
  }, [_c('div', {
    staticClass: "commentary__title-row"
  }, [_vm.comment.name ? _c('div', {
    staticClass: "commentary__title h3"
  }, [_vm._v("\n        " + _vm._s(_vm.comment.name) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.comment.date ? _c('div', {
    staticClass: "commentary__date p p_grey"
  }, [_vm._v("\n        " + _vm._s(_vm.comment.date) + "\n      ")]) : _vm._e()]), _vm._v(" "), _vm.comment.text ? _c('div', {
    staticClass: "commentary__text p p_lh21"
  }, [_vm._v("\n      " + _vm._s(_vm.comment.text) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.comment.id ? _c('Toggle', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var onClick = _ref.onClick,
            isActive = _ref.isActive;
        return [_c('div', {
          staticClass: "commentary__tools"
        }, [_c('div', {
          staticClass: "commentary__tool"
        }, [_c('span', {
          staticClass: "commentary__button",
          on: {
            "click": onClick
          }
        }, [_vm._v("Ответить")])]), _vm._v(" "), _c('div', {
          staticClass: "commentary__tool"
        }, [_c('UIActionList', {
          attrs: {
            "actions": {
              like: _vm.$api.question.likeComment,
              dislike: _vm.$api.question.dislikeComment
            }
          },
          on: {
            "like:success": function ($event) {
              return _vm.onClickThumbs($event, 'like');
            },
            "dislike:success": function ($event) {
              return _vm.onClickThumbs($event, 'dislike');
            },
            "like:error": _vm.onError,
            "dislike:error": _vm.onError
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var like = _ref2.like,
                  dislike = _ref2.dislike;
              return [_c('ReviewsThumbs', {
                attrs: {
                  "like": _vm.likes,
                  "dislike": _vm.dislikes,
                  "active-like": _vm.activeLike,
                  "active-dislike": _vm.activeDislike
                },
                on: {
                  "positive": function ($event) {
                    return like.request({
                      id: _vm.comment.id,
                      questionId: _vm.questionId
                    });
                  },
                  "negative": function ($event) {
                    return dislike.request({
                      id: _vm.comment.id,
                      questionId: _vm.questionId
                    });
                  }
                }
              })];
            }
          }], null, true)
        })], 1)]), _vm._v(" "), isActive ? _c('div', {
          staticClass: "commentary__response"
        }, [_c('div', {
          staticClass: "commentary__response-wrapper"
        }, [_vm._t("answer", null, {
          "comment": _vm.comment.name,
          "parentId": _vm.questionId
        })], 2)]) : _vm._e()];
      }
    }], null, true)
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }